import { Line, LineChart, ResponsiveContainer, YAxis } from "recharts";
import { viz } from "../../styles";

/**
 * Inline trend for a stat tile. No axes, no tooltip — it carries shape only,
 * and the tile's own value carries the number. Never the sole source of a
 * figure anyone has to read.
 */
const Sparkline = <T extends Record<string, any>>({
  data,
  dataKey,
  color = viz.series1,
  height = 32,
}: {
  data: T[];
  dataKey: string;
  color?: string;
  height?: number;
}) => {
  if (data.length < 2) return null;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 2, right: 0, bottom: 2, left: 0 }}>
        <YAxis hide domain={["dataMin", "dataMax"]} />
        <Line
          type="monotone"
          dataKey={dataKey}
          stroke={color}
          strokeWidth={2}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default Sparkline;
